// Shimmering placeholder rectangle used while data is loading.
// Renders a div with a moving gradient sweep (see .juuplan-skeleton in
// styles/index.css). Width/height accept any valid CSS length; `rounded`
// toggles the corner radius (defaults to `var(--radius-DEFAULT)`).

interface Props {
  width?: string | number;
  height?: string | number;
  class?: string;
  rounded?: string | boolean;
}

function toCss(value: string | number | undefined): string | undefined {
  if (value === undefined) return undefined;
  return typeof value === "number" ? `${value}px` : value;
}

export function LoadingSkeleton(props: Props): preact.JSX.Element {
  const { width, height, rounded } = props;
  const radius =
    rounded === false
      ? "0"
      : typeof rounded === "string"
      ? rounded
      : "var(--radius-DEFAULT)";

  return (
    <div
      class={`juuplan-skeleton ${props.class ?? ""}`}
      style={{
        width: toCss(width) ?? "100%",
        height: toCss(height) ?? "1rem",
        borderRadius: radius,
      }}
      aria-hidden="true"
    />
  );
}
